const LearningReminder = () => {
  return (
    <h1 className="text-lg font-bold text-gray-600 mb-1">Learning Reminder</h1>
  );
};

export default LearningReminder;
